import React from 'react';
import '../Steps.scss';
import { StepHeader } from './Header';
import { StepControls } from './Controls';
import { StepProps } from '../Steps';
import thirdStepImage from './TourImages/thirdStep.jpg';

export const ThirdStep = (props: StepProps) => {
  return (
    <div className="step-container">
      <StepHeader {...props} />
      <div className="step-container__title">
        Reach new customers on Facebook with Click-to-Messenger Ads, and
        re-engage existing Leads with Chat Blasts, Drip Campaigns, and Sponsored
        Messages:
      </div>
      <div className="step-container__description-image-container">
        <img
          className="step-container__description-image"
          src={thirdStepImage}
        />
      </div>
      <StepControls {...props} />
    </div>
  );
};
